// Generated by purs version 0.15.15
import * as Data_Lazy from "../Data.Lazy/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Foliage_Program from "../Foliage.Program/index.js";
var blank = /* #__PURE__ */ Data_Lazy.defer(function (v) {
    return new Foliage_Program.Module({
        name: "Blank",
        doc: Data_Maybe.Nothing.value,
        initialGas: 100,
        dataTypeDefs: Data_Map_Internal.empty,
        functionDefs: Data_Map_Internal.empty,
        latticeTypeDefs: Data_Map_Internal.empty,
        relations: Data_Map_Internal.empty,
        rules: Data_Map_Internal.empty
    });
});
export {
    blank
};
